<mat-card class="cardWithShadow">
  <mat-card-content style="padding: 36px 36px 0px 36px">
    <h2 style="font-weight: 600; line-height: 32px; color: #111827">
      Ver Proveedores
    </h2>

    <div *ngIf="isLoading" class="spinner">
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
      <p>Cargando Proveedores...</p>
    </div>
    <div *ngIf="!isLoading" class="row justify-content-between">
      <div class="col-sm-4 w-100">
        <mat-form-field appearance="outline" class="w-100 hide-hint">
          <input
            matInput
            placeholder="Buscar..."
            (keyup)="applyFilter($event)"
          />
          <mat-icon matSuffix>
            <i-tabler name="search" class="icon-20"></i-tabler>
          </mat-icon>
        </mat-form-field>
      </div>
      <div class="w-100 col-sm-4">
        <button mat-raised-button color="primary" (click)="openDialog()">
          Crear Proveedor
        </button>
      </div>
    </div>
  </mat-card-content>
  <mat-card-content
    [style.display]="
      !isLoading && dataSource.filteredData.length !== 0 ? 'block' : 'none'
    "
    style="padding: 36px"
  >
    <div *ngIf="!isLoading" class="table-responsive">
      <table
        mat-table
        matSort
        [dataSource]="dataSource"
        class="no-wrap m-t-0 v-middle w-100"
      >
        <ng-container matColumnDef="id">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            ID
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.codigoProveedor }}
          </td>
        </ng-container>

        <ng-container matColumnDef="nombreComercial">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            NOMBRE COMERCIAL
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.nombreComercial }}
          </td>
        </ng-container>

        <ng-container matColumnDef="razonSocial">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            RAZÓN SOCIAL
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.razonSocial }}
          </td>
        </ng-container>

        <ng-container matColumnDef="provincia">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            PROVINCIA
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.provincia }}
          </td>
        </ng-container>

        <ng-container matColumnDef="distrito">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            DISTRITO
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.distrito }}
          </td>
        </ng-container>

        <ng-container matColumnDef="direccionSocial">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            DIRECCIÓN SOCIAL
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.direccionSocial }}
          </td>
        </ng-container>

        <ng-container matColumnDef="documento">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            NRO DOCUMENTO
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.documento }}
          </td>
        </ng-container>

        <ng-container matColumnDef="ruc">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            RUC
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.ruc }}
          </td>
        </ng-container>

        <ng-container matColumnDef="telefono">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            TELÉFONO
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.telefono }}
          </td>
        </ng-container>

        <ng-container matColumnDef="ccSoles">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            CUENTA CONTABLE SOLES
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.cuentaContableSoles }}
          </td>
        </ng-container>

        <ng-container matColumnDef="ccDolares">
          <th
            mat-sort-header
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            CUENTA CONTABLE DÓLARES
          </th>
          <td class="f-s-14 custom-column" mat-cell *matCellDef="let element">
            {{ element?.cuentaContableDolares }}
          </td>
        </ng-container>

        <ng-container matColumnDef="modificar">
          <th
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            EDITAR
          </th>
          <td
            class="f-s-14 custom-column"
            mat-cell
            *matCellDef="let element; let i = index"
          >
            <button mat-icon-button (click)="openDialog(element)">
              <mat-icon color="primary">edit</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="eliminar">
          <th
            class="f-w-600 f-s-15 custom-column"
            mat-header-cell
            *matHeaderCellDef
          >
            ELIMINAR
          </th>
          <td
            class="f-s-14 custom-column"
            mat-cell
            *matCellDef="let element; let i = index"
          >
            <button
              mat-icon-button
              color="primary"
              (click)="deleteSKU(element)"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>

    <div [hidden]="isLoading">
      <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons>
      </mat-paginator>
    </div>
  </mat-card-content>

  <div
    *ngIf="!isLoading && dataSource?.filteredData?.length === 0"
    class="d-flex justify-content-center align-items-center"
    style="width: 100%; height: 400px; text-align: center"
  >
    Lo sentimos. No tenemos datos para esta búsqueda.
    <br />Por favor, intenta con otro término.
  </div>
</mat-card>
